var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"r-icon"},[_c('img',{attrs:{"src":_vm.src,"alt":"triangle with all three sides equal","height":"87","width":"100"}})])}
var staticRenderFns = []
export { render, staticRenderFns }